import { Injectable } from '@angular/core';

@Injectable()
export class PlatformService {
  public dpr = window.devicePixelRatio || 1;
}
